import * as React from 'react';

import BaseSettingsTeamLayout from './BaseSettingsTeamLayout';
import UserCreatePopup from '../containers/users/UserCreatePopupWrapper';

export default function (params) {
  return BaseSettingsTeamLayout(
    <UserCreatePopup />
  );
};
